import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { BedDouble, Menu, Plane, Ticket, Trophy, X } from "lucide-react";
import { useWallet } from "../services/wallet.service";
import { MemberProfileDropdown } from "./MemberProfileDropdown";

const LINKS = [
  { to: "/member", label: "Stays", icon: BedDouble, end: true },
  { to: "/member/flights", label: "Flights", icon: Plane, end: false },
  { to: "/member/trips", label: "Trips", icon: Ticket, end: false },
  { to: "/member/rewards", label: "Rewards", icon: Trophy, end: false },
];

export function TravelHeader() {
  const wallet = useWallet();
  const [open, setOpen] = useState(false);

  return (
    <header className="z-30 bg-[#003580] text-white">
      <div className="mx-auto flex max-w-6xl items-center gap-4 px-4 py-3 sm:px-6">
        <Link to="/member" className="shrink-0">
          <span className="block text-lg font-bold leading-none tracking-tight">
            Perk Point
          </span>
          <span className="text-[11px] text-white/70">Stays and flights</span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 md:flex">
          {LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              className={({ isActive }) =>
                `inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium ${
                  isActive ? "bg-white/15" : "hover:bg-white/10"
                }`
              }
            >
              <link.icon className="h-4 w-4" />
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <Link
            to="/member/rewards"
            className="hidden items-center gap-2 rounded-full bg-[#febb02] px-3 py-1.5 text-sm font-semibold text-[#1a1a1a] sm:inline-flex"
          >
            {wallet.points.toLocaleString("en-IN")} pts
            {wallet.pendingPoints > 0 ? (
              <span className="font-medium text-[#1a1a1a]/70">
                · {wallet.pendingPoints.toLocaleString("en-IN")} pending
              </span>
            ) : null}
            <span className="font-medium text-[#1a1a1a]/70">· {wallet.tierName}</span>
          </Link>
          <MemberProfileDropdown />
          <button
            type="button"
            className="rounded-md p-2 hover:bg-white/10 md:hidden"
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen((value) => !value)}
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open ? (
        <div className="space-y-1 border-t border-white/10 px-4 py-3 md:hidden">
          <Link
            to="/member/rewards"
            onClick={() => setOpen(false)}
            className="mb-2 inline-flex rounded-full bg-[#febb02] px-3 py-1 text-sm font-semibold text-[#1a1a1a]"
          >
            {wallet.points.toLocaleString("en-IN")} pts
            {wallet.pendingPoints > 0 ? ` · ${wallet.pendingPoints.toLocaleString("en-IN")} pending` : ""}
            {` · ${wallet.tierName}`}
          </Link>
          {LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              onClick={() => setOpen(false)}
              className="flex items-center gap-2 rounded-md px-2 py-2 text-sm hover:bg-white/10"
            >
              <link.icon className="h-4 w-4" />
              {link.label}
            </NavLink>
          ))}
        </div>
      ) : null}
    </header>
  );
}
